var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmallArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Vector 414",
  stroke: "#fff",
  d: "M5.813-.05 11.863 6l-6.05 6.052"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "Vector 415",
  stroke: "#fff",
  d: "M11.864 6H-.864"
})));
export { SvgSmallArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGlkPSJWZWN0b3IgNDE0IiBkPSJNNS44MTI1IC0wLjA1MDc4MTJMMTEuODYzOSA2LjAwMDYxTDUuODEyNDggMTIuMDUyIiBzdHJva2U9IndoaXRlIiAvPgogICAgPHBhdGggaWQ9IlZlY3RvciA0MTUiIGQ9Ik0xMS44NjQgNi4wMDA2OEwtMC44NjM5NDIgNi4wMDA3IiBzdHJva2U9IndoaXRlIiAvPgo8L3N2Zz4=";